import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ewm",
  "use": "icon-ewm-usage",
  "viewBox": "0 0 35 35",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 35\" id=\"icon-ewm\">\r\n  <g transform=\"matrix(1 0 0 1 -339 -25 )\">\r\n    <path d=\"M 371.585786437627 59  L 340 27.4142135623731  L 340 59  L 371.585786437627 59  Z \" fill-rule=\"nonzero\" fill=\"#ffffff\" stroke=\"none\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ewm.svg
// module id = +I6Z
// module chunks = 0